import { Menu } from '../models/menu.model';

export const MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: 'dashboard',
    title: 'Dashboard',
  },
];
